// NOTE: it's not a provider in terms of checkout mobile architectrue, it's just "control".
var VisaPaymentBTProvider = (function (CheckoutApiModel, GlobalSettings, CheckoutSettings) {

	var formButtonsContainer = '#bt-checkout-form-buttons';
	var checkoutButtonsContainer = '#bt-checkout-buttons-current';
	var allButtonsContainer = '#bt-checkout-buttons-all';

	var addMethodButton,
		currentMethodButton,
		newMethodButton;

	var displayButtons = false;
	var displayButtonsNew = true;

	var VisaPaymentProvider = CheckoutApiModel.extend({
		_place: null,

        type: CheckoutSettings.PaymentType.VisaCheckoutBT,
        paymentOption: CheckoutSettings.PaymentOption.VisaCheckoutBrainTree,

		initialize: function (set, opt) {

			_.bindAll(this, '_initVisa', '_addButtons', '_summaryChanged', '_prepayment', '_complete', '_toggleButtons');

			this._order = opt.order;
			this._current = opt.current;
			this._service = opt.service;
			this._visaSettings = CheckoutSettings.getBasketSettings().Visa;
			this._handleValidtion = opt.handleValidtion;
			this._bt = opt.bt;
			this.currentMode = 1;

			if (this._visaSettings.Enabled) {
				this._addButtons();
				this._order.get('Summary').on('change', this._summaryChanged);
                this._order.on('change', _.bind(function (order) {
                    this._toggleButtonsOnOrder(order);
				}, this));

                opt.changeModeHandler.on('changeMode', this._toggleButtons);

                this._current.on('change', _.bind(function (model) {
                    this._toggleButtonsOnPaymentMethod(model);
                }, this));

				// NOTE: if smth will go wrong after display change (fail with DOM buttons, wrong reinits of visa checkout, etc)
				DisplayRouter.GlobalDisplayHook.on(DisplayRouter.GlobalDisplayHook.eventTypes.changeDisplay, _.bind(function (place) {
					this._place = place;
                    this._summaryChanged(opt.order.get('Summary'));
                    this._toggleButtonsOnPaymentMethod(this._current);
                    this._toggleButtonsOnOrder(this._order);
				}, this));
				this._initVisa().then(_.bind(function () {
					this._summaryChanged(opt.order.get('Summary'));
                    this._toggleButtonsOnPaymentMethod(this._current);
                    this._toggleButtonsOnOrder(this._order);
                }, this));
			}
        },

        _toggleButtonsOnOrder: function (order) {
            displayButtonsNew = _.some(this._order.attributes.AvailablePaymentOptions,
                function (po) {
                    return po.Name.toLowerCase() === CheckoutSettings.PaymentOption.VisaCheckoutBrainTree.toLowerCase();
                });
            newMethodButton.toggle(displayButtonsNew && this.currentMode === 1);
            //addMethodButton.toggle(displayButtonsNew);
        },

        _toggleButtonsOnPaymentMethod: function (model) {
            displayButtons = model.get('PaymentType') === CheckoutSettings.PaymentType.VisaCheckoutBT;
            currentMethodButton.toggle(displayButtons);
        },

		_initVisa: function () {
			visa_checkout_instance.init(this._visaSettings.APIUrl);
			visa_checkout_instance.init(this._visaSettings.APIUrl);
			return visa_checkout_instance.init(this._visaSettings.APIUrl);
		},

		_summaryChanged: function (model) {
			this._addButtons();
			// NOTE: do not init if no total
			if (!model.toJSON().TotalWithSelect) {
				return;
			}
			this._bt.visaCheckout.initVisaLiteBox(model.toJSON().TotalWithSelect, this._complete);
		},

        _addButton: function (data, appendToEl, currentButton, tmpl) {
			var button = visa_checkout_button.getbutton(data, this._prepayment, this._visaSettings.APIUrl, tmpl);
            button.find('img').css('width', '100%').css('height', '100%');
			if (currentButton) {
				currentButton.replaceWith(button);
			} else {
				button.appendTo(appendToEl);
			}
			return button;
		},

		_addButtons: function () {
			//addMethodButton = this._addButton({ id: 'checkoutVisa', role: 'checkoutVisa', testClass: 'test-visa-button' }, $(formButtonsContainer), addMethodButton);
			currentMethodButton = this._addButton({ id: 'bt-checkout-buttons-current-visa', role: 'bt-checkout-buttons-current-visa', testClass: 'test-visa-button' }, $(checkoutButtonsContainer), currentMethodButton, 'bt-checkout-button-braintree-vco');
			newMethodButton = this._addButton({ id: 'bt-checkout-buttons-visa', role: 'bt-checkout-buttons-visa', testClass: 'test-visa-button' }, $(allButtonsContainer), newMethodButton);
			currentMethodButton.toggle(displayButtons);
			newMethodButton.toggle(displayButtonsNew && this.currentMode === 1);
			//addMethodButton.toggle(displayButtonsNew);
		},

        _toggleButtons: function(e, mode) {
			this.currentMode = mode || 1;
            this._addButtons();
        },

		_prepayment: function () {
			var def = new $.Deferred();

		    var isCurrent = this._current.get('PaymentType') === CheckoutSettings.PaymentType.VisaCheckoutBT;

		    if (isCurrent) {
		        window.app && app.event && app.event.currentVisacheckout();
		    } else {
		        window.app && app.event && app.event.visacheckout();
		    }

			var value = this._service.checkValid();
			if (value.result) {
				// NOTE: if current payment method is VCBT then do not show popup and just do create payment transaction.
				// NOTE: only NOT for form view!
				if (isCurrent) {
					this._complete({
						token: this._current.get('Token')
					});
				} else {
					def.resolve();
				}
			} else {
				(new this._handleValidtion()).handle(value.reason,
					{
						backTo: 'checkout'
					});
			}
			return def.promise();
		},

        _complete: function (method) {
            var deviceData = this._bt.kount.getDeviceData();
            this._service._paymentStrategy.beforeProcess(method)
                .then(_.bind(this._service._paymentStrategy.betweenProcessAndComplete, this._service._paymentStrategy, { Nonce: method.nonce }))
                .then(function (data) {
                    if (data.Nonce) {
                        return {
                            nonce: data.Nonce,
                            token: null
                        }
                    }
                    return method;
                })
                .then(_.bind(function (data) {
                    var transactionData = {
                        paymentType: this.type,
                        selectedPaymentOption: this.paymentOption,
                        paymentNonce: data.nonce || '',
                        paymentToken: data.token || '',
                        deviceData: deviceData
                    };
                    return transactionData;
                }, this))
                .then(_.bind(function (transactionData) {
                    return this._createPaymentTransaction(transactionData, { wait: true, preventDoubleRequests: true });
                }, this))
                .then(_.bind(this._service._paymentStrategy.afterComplete, this._service._paymentStrategy));
        },

		setService: function (service) {
            this._service = service;
        },
	});

	return VisaPaymentProvider;
})(CheckoutApiModel, GlobalSettings, CheckoutSettings);
